(function(){
  function updateCount(n){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = n; });
  }
  function toast(msg){
    var existing = document.querySelector('.sp-toast'); if(existing) existing.remove();
    var t = document.createElement('div');
    t.className = 'sp-toast';
    t.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'
      + '<span>' + msg + '</span><a href="/cart">Zum Warenkorb &rarr;</a>';
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('sp-toast--show'); });
    setTimeout(function(){ t.classList.remove('sp-toast--show'); setTimeout(function(){ if(t.parentNode) t.remove(); }, 320); }, 4200);
  }
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form.classList || !form.classList.contains('product-form')) return;
    if(e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.dataset.orig = orig; btn.textContent = 'Wird hinzugefügt …'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
    .then(function(cart){ updateCount(cart.item_count); toast('Zum Warenkorb hinzugefügt'); })
    .catch(function(){ form.submit(); })
    .finally(function(){ if(btn){ btn.disabled = false; btn.textContent = btn.dataset.orig || orig; } });
  });
})();
